if (!customElements.get('category-banner-video')) {
  class CategoryBannerVideo extends HTMLElement {
    connectedCallback() {
      this.videos = [...this.querySelectorAll('video')];
      this.button = this.querySelector('.category-banner__toggle');
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      this.mobile = matchMedia('(max-width: 920px)');
      this.userPaused = false;
      this.inView = false;
      this.button.addEventListener('click', () => {
        this.userPaused = this.videos.some(video => !video.paused && video.getClientRects().length);
        this.sync();
      }, options);
      this.reducedMotion.addEventListener('change', () => this.sync(), options);
      this.mobile.addEventListener('change', () => this.sync(), options);
      document.addEventListener('visibilitychange', () => this.sync(), options);
      this.videos.forEach(video => {
        video.addEventListener('play', () => this.updateButton(), options);
        video.addEventListener('pause', () => this.updateButton(), options);
      });
      this.observer = new IntersectionObserver(entries => {
        this.inView = entries[0].intersectionRatio > 0;
        this.sync();
      }, { threshold: [0, 0.01] });
      this.observer.observe(this);
      this.sync();
    }

    disconnectedCallback() {
      this.events.abort();
      this.observer.disconnect();
      this.videos.forEach(video => video.pause());
    }

    sync() {
      const visible = this.videos.filter(video => video.getClientRects().length);
      const shouldPlay = this.inView && !document.hidden && !this.reducedMotion.matches && !this.userPaused;
      this.button.hidden = this.reducedMotion.matches || visible.length === 0;
      this.videos.forEach(video => {
        if (shouldPlay && visible.includes(video)) {
          if (video.paused) video.play().catch(() => {
            if (this.isConnected) this.updateButton();
          });
        } else {
          video.pause();
        }
      });
      this.updateButton();
    }

    updateButton() {
      const playing = this.videos.some(video => !video.paused && video.getClientRects().length);
      this.button.dataset.paused = String(!playing);
      this.button.setAttribute('aria-label', playing ? this.button.dataset.pauseLabel : this.button.dataset.playLabel);
    }
  }

  customElements.define('category-banner-video', CategoryBannerVideo);
}
